import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Container, Table, UserInfo } from './style';
import { RiPencilLine } from 'react-icons/ri';
import { useAuth } from '../../contexts/Auth';
import EnableMfaModal from '../../components/Modal/EnableMfaModal/EnableMfaModal';
import DisableMfaModal from '../../components/Modal/DisableMfaModal/DisableMfaModal';
import { useNavigate } from 'react-router-dom';

const UserSettings: React.FC = () => {
  const { refactoredUser } = useAuth();
  const navigate = useNavigate();
  const isEmbedded = window.self !== window.top;

  const [enableMfaModalOpen, setEnableMfaModalOpen] = useState(false);
  const [disableMfaModalOpen, setDisableMfaModalOpen] = useState(false);

  const openMfaModal = () => {
    refactoredUser?.isMFAEnabled() ? setDisableMfaModalOpen(true) : setEnableMfaModalOpen(true);
  };

  useEffect(() => {
    if (refactoredUser && refactoredUser?.isFederated()) {
      navigate('/', {
        replace: true,
      });
    }
  }, [refactoredUser]);

  return (
    <>
      <EnableMfaModal
        open={enableMfaModalOpen}
        closeModalFunc={() => setEnableMfaModalOpen(false)}
      />
      <DisableMfaModal
        open={disableMfaModalOpen}
        closeModalFunc={() => setDisableMfaModalOpen(false)}
      />

      {/* <TitleContainer>
      <MainTitleWrapper>
        <Title>User Settings</Title>
      </MainTitleWrapper>
      </TitleContainer> */}

      {isEmbedded && refactoredUser && (
        <UserInfo>
          <div>User: {refactoredUser.username}</div>
          <div>Role: {refactoredUser.getRoles().join(', ')}</div>
        </UserInfo>
      )}

      <Container>
        <Table>
          <tr>
            <td>Multi-factor authentication</td>
            <td>
              <strong>{refactoredUser?.isMFAEnabled() ? 'Enabled' : 'Disabled'}</strong>
            </td>
            <td>
              <Button
                onClick={() => openMfaModal()}
                variant="light"
                shape="round"
                loading={enableMfaModalOpen || disableMfaModalOpen}
              >
                <RiPencilLine />
              </Button>
            </td>
          </tr>
        </Table>
      </Container>
    </>
  );
};

export default UserSettings;
